import {StoreState} from '@/app/store';

export const selectRecentLocations = (state: StoreState) => state.locationsHistory.recentLocations;
export const selectSearchHistory = (state: StoreState) => state.locationsHistory.searchHistory;
export const selectSearchHistoryIsLoaded = (state: StoreState) => state.locationsHistory.searchHistoryLoaded;
